import * as THREE from 'three'
import { React, useRef, useEffect, useState, useMemo } from 'react'
import { Canvas, extend, useFrame, useThree, useKeyboard } from '@react-three/fiber'
import { Splat, Float, CameraControls, Environment, KeyboardControls, StatsGl, Effects, Sky } from '@react-three/drei'
import ReactNipple from 'react-nipple'
import * as holdEvent from "./hold-event.module.js";
// import { Physics, RigidBody, CuboidCollider, BallCollider } from '@react-three/rapier'
// import { TAARenderPass } from 'three/examples/jsm/postprocessing/TAARenderPass'
// import { OutputPass } from 'three/examples/jsm/postprocessing/OutputPass'
// import { useControls } from 'leva'

// VR模拟器 //////////////////////////////////////
// import { XRDevice, metaQuest3 } from "iwer";
// const xrDevice = new XRDevice(metaQuest3);
// xrDevice.installRuntime();
///////////////////////////////////////////////////

// XR支持 ////////////////////////////////////////
import { XR, createXRStore } from '@react-three/xr'

// 判断系统是否支持WEBXR，支持才显示VR按钮
let supportXR = false
let XRstore = null

//检查 navigator 中是否包含 xr
if ('xr' in navigator){
  //检查 沉浸式VR 是否支持
  async function checkXRSupport() {
    navigator.xr.isSessionSupported('immersive-vr').then(function (supported) {
      supportXR = supported
    })
  }
  await checkXRSupport()
}else {
  if (window.isSecureContext === false) {
    // console.log(`WEBXR 需要 HTTPS`);
  } else {
    // console.log(`WEBXR 不可用`);
  }
}

if (supportXR) {
  XRstore = createXRStore()
}

const joystickSize = 100 // 手柄圆圈的尺寸
const assetsFolder = 'assets/' // 模型和配置文件存放路径
const skyboxFolder = 'skybox/' // 天空盒存放路径

const SceneTypes = {
  model: 0, // 模型
  roaming: 1, // 漫游
  hover: 2 // 盘旋飞行
}

const ModelType = {
  splat: 0, // .splat文件
  mesh: 1 // 网格模型
}

let cameraControlsRef = null
let cameraRef = null
var cameraFacingVector = new THREE.Vector3(); // create once and reuse it!

////////////////////////////////////////////////
// 调试时使用
// const projectName = 'test' // test漫游，test1模型，test2飞行
// 编译时使用
const projectName = GetQueryString( 'name' )
////////////////////////////////////////////////

const projectFile = assetsFolder + projectName + '.json'

async function getConfig(){
  // 读取配置文件
  try {
    const res = await fetch( projectFile );
    const json = await res.json();

    let data = json

    if ( data.speed === undefined ) // 移动速度
      data.speed = 1
    data.speed *= 0.0001

    if ( data.type === 2) 
      data.type = SceneTypes.hover
    else if ( data.type === 1 )
      data.type = SceneTypes.roaming
    else
      data.type = SceneTypes.model

    for ( var i = 0; i < data.models.length; i++ ) {
      if ( data.models[i].modelType === 0 )
        data.models[i].modelType = ModelType.splat
      else
        data.models[i].modelType = ModelType.mesh
      if ( data.models[i].rotation !== undefined ) {
        data.models[i].rotation[0] *= ( Math.PI / 180 )
        data.models[i].rotation[1] *= ( Math.PI / 180 )
        data.models[i].rotation[2] *= ( Math.PI / 180 )
      }
    }

    return data;
  } catch( error ) {
    console.log( 'Config error: ', error )
  }
}

// 获取配置信息
const projectData = await getConfig()

// 天空盒文件
const skyboxFile = skyboxFolder + projectData.skybox
// 隐藏游戏手柄
const joystickHidden = ( projectData.type === SceneTypes.model ) ? true : false

export default function App() {
  return (
    <>
      {
        supportXR ? (
          <button style={{ position: 'absolute',
              bottom: '50px', right: '50px',
              width: '100px', height: '100px',
              zIndex: '99999',        
              background: '#FFFFFF3F',
              border: 'none',
              color: '#FFFFFF6F',
              borderRadius: '50px',
              fontSize: '22px',
              // visibility: supportXR ? 'visible' : 'hidden'
            }}
              onClick={() => XRstore.enterVR()}>
            VR
          </button>
        ) : ( <></> )
      }
      <div style = {{ position: 'relative', width: '100%', height: '100%' }}>
        <Canvas 
          style = {{ position: 'absolute', width: '100%', height: '100%' }}
          dpr = { 1.5 }
          gl={{ antialias: true }}
          camera = {{ 
            fov: (projectData.cameraProp.fov !== undefined) ? projectData.cameraProp.fov : 50
          }}>
          <color attach = "background" args = {[ 'black' ]} />
          {/* <Sky sunPosition={[100, 100, 20]} /> */}
          {
            // 显示天空盒
            ( projectData.skybox !== undefined && projectData.skybox !== '' ) ? ( <Environment background files = {skyboxFile} /> ) : ( <> </> )
          }
          {
            supportXR ? (
              <>
                <XR store={XRstore}>
                  <Scene />
                </XR>
              </>
            ) : (
              <Scene />
            )
          }
        </Canvas>

        <div style={{ position: 'absolute',
          bottom: '50px', left: '50px',
          width: '100px', height: '100px',
          visibility: joystickHidden ? 'hidden' : 'visible',
          zIndex: '99999' }}
        >
          <ReactNipple
            // see https://github.com/yoannmoinet/nipplejs#options
            options={{ mode: 'static', position: { top: '50%', left: '50%' } }}
            style={{
                //  outline: `1px dashed red`,
                width: {joystickSize},
                height: {joystickSize},
                // position: 'relative'
                // if you pass position: 'relative', you don't need to import the stylesheet
            }}
            // all events supported by nipplejs are available as callbacks
            // see https://github.com/yoannmoinet/nipplejs#start
            onStart = { handleJoystickEvent }
            onEnd = { handleJoystickEvent }
            onMove = { handleJoystickEvent }
            onDir = { handleJoystickEvent }
            onPlain = { handleJoystickEvent }
            onShown = { handleJoystickEvent }
            onHidden = { handleJoystickEvent }
            onPressure = { handleJoystickEvent }
            
          />
        </div>
      </div>
    </>
  )
}

const Scene = () => {
  cameraControlsRef = useRef()
  const { camera } = useThree()
  cameraRef = camera
  
  const cameraposition = ( projectData.cameraProp !== undefined && projectData.cameraProp.position !== undefined ) 
                          ? projectData.cameraProp.position : [0, 0, 0]

  if ( projectData.type === SceneTypes.roaming ) {
    const EPS = 1e-5;
    // in order to archive FPS look, set EPSILON for the distance to the center
    camera.position.set( 0, 0, EPS )
  } else {
    camera.position.set( cameraposition[0], cameraposition[1], cameraposition[2] )
  }

  let polar = 0.0, minPolar = 0.0, maxPolar = 180.0
  let azimuth = 0.0, minAzimuth = 0.0, maxAzimuth = 360.0
  if ( projectData.type === SceneTypes.roaming || projectData.type === SceneTypes.hover ) {
    if ( projectData.cameraProp !== undefined ) {

      // 极角
      if ( projectData.cameraProp.polarAngle !== undefined)
        polar = projectData.cameraProp.polarAngle
      if ( projectData.cameraProp.minPolarAngle !== undefined)
        minPolar = projectData.cameraProp.minPolarAngle
      if ( projectData.cameraProp.maxPolarAngle !== undefined)
        maxPolar = projectData.cameraProp.maxPolarAngle            
      // 方位角
      if ( projectData.cameraProp.azimuthAngle !== undefined)
        azimuth = projectData.cameraProp.azimuthAngle
      if ( projectData.cameraProp.minAzimuthAngle !== undefined)
        minAzimuth = projectData.cameraProp.minAzimuthAngle
      if ( projectData.cameraProp.maxAzimuthAngle !== undefined)
        maxAzimuth = projectData.cameraProp.maxAzimuthAngle
    }
  }

  let rotatespeed = 1.0
  if ( projectData.cameraProp !== undefined )
      if ( projectData.cameraProp.rotateSpeed !== undefined)
        rotatespeed = projectData.cameraProp.rotateSpeed * 0.5

  useFrame(() => {
  
  })

  return (
    <>
      <group> {/* position-y={-0.5}> */}
        <CameraControls makeDefault
          ref = {cameraControlsRef}

          polarAngle = { ( projectData.type === SceneTypes.roaming || projectData.type === SceneTypes.hover ) 
            ? ( polar * Math.PI / 180 ) : ( Math.PI / 2 ) }

          minPolarAngle = { ( projectData.type === SceneTypes.roaming || projectData.type === SceneTypes.hover ) 
            ? ( minPolar * Math.PI / 180 ) : ( 0.0 ) }

          maxPolarAngle = { ( projectData.type === SceneTypes.roaming || projectData.type === SceneTypes.hover ) 
            ? ( maxPolar * Math.PI / 180 ) : ( Math.PI ) }

          azimuthAngle = { ( projectData.type === SceneTypes.roaming || projectData.type === SceneTypes.hover ) 
            ? ( azimuth * Math.PI / 180 ) : ( 3 * Math.PI / 2 ) }

          // minAzimuthAngle = { ( projectData.type === SceneTypes.model ) 
          //   ? ( minAzimuth * Math.PI / 180 ) : ( 3 * Math.PI / 2 ) }

          // maxAzimuthAngle = { ( projectData.type === SceneTypes.model ) 
          //   ? ( maxAzimuth * Math.PI / 180 ) : ( 3 * Math.PI / 2 ) }

          azimuthRotateSpeed = { rotatespeed }
          polarRotateSpeed = { rotatespeed }

          // minZoom = { 0.1 }
          // maxZoom = { 0.5 }

          // smoothTime = { 0.25 }
          // draggingSmoothTime = { 0.125 }
        />
        <CustomKeyboardControls />
        <Models />
      </group>
    </>
  )
}

const Models = () => {
  let modellist = []
  if ( projectData.models !== undefined ) {
    for ( var i = 0; i < projectData.models.length; i++ ) {
      const model = projectData.models[i]

      let modelname = model.name
      const modelposition = ( model.position === undefined ) ? [0, 0, 0] : model.position
      const modelrotation = ( model.rotation === undefined ) ? [0, 0, 0] : model.rotation
      const modelscale = ( model.scale === undefined ) ? [1, 1, 1] : model.scale
      if ( modelname !== undefined && modelname !== '') {
        if ( model.modelType === ModelType.splat ) {
          modelname = assetsFolder + modelname + '.splat'
          modellist.push(
            <Splat alphaTest={0.1} key={model.id} src={`${modelname}`} position={ modelposition } rotation={ modelrotation } scale={ modelscale } />
          )
        }
      }
    }
  }
  return ( 
    <>
      {modellist}
    </>
  )
}

function moveLeftOrRight( direction, speed ) {
  if ( direction === 'left' || direction === 'right' ) {
    let d = ( direction === 'left' ) ? -1 : 1
    cameraControlsRef.current.truck( d * speed, 0, false )
  }
}
function moveForwordOrBackword(direction, speed) {
  if ( direction === 'forword' || direction === 'backword' ) {
    let d = ( direction === 'backword' ) ? -1 : 1

    cameraRef.getWorldDirection( cameraFacingVector )
    let angle = Math.atan( cameraFacingVector.y / Math.sqrt( Math.pow( cameraFacingVector.x, 2 ) + Math.pow( cameraFacingVector.z, 2 )))

    // 如果是漫游，则只能水平移动
    if ( projectData.type === SceneTypes.roaming )
      angle = 0

    let hspeed = speed * Math.cos( angle )
    let vspeed = speed * Math.sin( angle )

    cameraControlsRef.current.forward( d * hspeed, false )
    cameraControlsRef.current.elevate( d * vspeed, false )
  }
}
function moveUpOrDown( direction, speed ) {
  if ( direction === 'up' || direction === 'down' ) {
    let d = ( direction === 'down' ) ? -1 : 1
    cameraControlsRef.current.elevate( d * speed, 0, false )
  }
}

function CustomKeyboardControls() {
  if ( projectData.type === SceneTypes.roaming || projectData.type === SceneTypes.hover ) { // 漫游和盘旋
    const KEYCODE = {
      W: 87,
      A: 65,
      S: 83,
      D: 68,
      Q: 81,
      E: 69,
      ARROW_LEFT : 37,
      ARROW_UP   : 38,
      ARROW_RIGHT: 39,
      ARROW_DOWN : 40,
    };
    const wKey = new holdEvent.KeyboardKeyHold( KEYCODE.W, 16.666 );
    const aKey = new holdEvent.KeyboardKeyHold( KEYCODE.A, 16.666 );
    const sKey = new holdEvent.KeyboardKeyHold( KEYCODE.S, 16.666 );
    const dKey = new holdEvent.KeyboardKeyHold( KEYCODE.D, 16.666 );
    const qKey = new holdEvent.KeyboardKeyHold( KEYCODE.Q, 16.666 );
    const eKey = new holdEvent.KeyboardKeyHold( KEYCODE.E, 16.666 );
    const leftKey  = new holdEvent.KeyboardKeyHold( KEYCODE.ARROW_LEFT,  16.666 );
    const rightKey = new holdEvent.KeyboardKeyHold( KEYCODE.ARROW_RIGHT, 16.666 );
    const upKey    = new holdEvent.KeyboardKeyHold( KEYCODE.ARROW_UP,    16.666 );
    const downKey  = new holdEvent.KeyboardKeyHold( KEYCODE.ARROW_DOWN,  16.666 );

    aKey.addEventListener( 'holding', event => moveLeftOrRight( 'left', projectData.speed * event.deltaTime ));
    dKey.addEventListener( 'holding', event => moveLeftOrRight( 'right', projectData.speed * event.deltaTime ));
    wKey.addEventListener( 'holding', event => moveForwordOrBackword( 'forword', projectData.speed * event.deltaTime ));
    sKey.addEventListener( 'holding', event => moveForwordOrBackword( 'backword', projectData.speed * event.deltaTime ));
    qKey.addEventListener( 'holding', event => moveUpOrDown( 'down', projectData.speed * event.deltaTime ));
    eKey.addEventListener( 'holding', event => moveUpOrDown( 'up', projectData.speed * event.deltaTime ));
    leftKey.addEventListener( 'holding', event => moveLeftOrRight( 'left', projectData.speed * event.deltaTime ));
    rightKey.addEventListener( 'holding', event => moveLeftOrRight( 'right', projectData.speed * event.deltaTime ));
    upKey.addEventListener( 'holding',  event => moveForwordOrBackword( 'forword', projectData.speed * event.deltaTime ));
    downKey.addEventListener( 'holding', event => moveForwordOrBackword( 'backword', projectData.speed * event.deltaTime ));
  }
}

let joystickTimer = null // 手柄计时器
let joystickStartTime = null // 手柄开始使用时间
let joystickXDirection = null // 'left' / 'right'
let joystickYDirection = null // 'up' / 'down'
let joystickDirectionAngle = 0.0 // 手柄指向角度
let joystickSpeed = 1.0 // 移动速度

function startJoystick() {

  joystickStartTime = new Date().getTime(); // 获取当前时间的毫秒数
  joystickTimer = setInterval(function() {
    let currentTime = new Date().getTime(); // 获取当前时间的毫秒数
    let elapsedTime = currentTime - joystickStartTime; // 计算经过的时间

    if ( elapsedTime >= 30 ) {

      let speed = joystickSpeed * 10 * projectData.speed
      let speedForword = speed * Math.abs( Math.sin( joystickDirectionAngle ))
      let speedTruck = speed * Math.abs( Math.cos( joystickDirectionAngle ))

      if ( joystickXDirection === 'left' || joystickXDirection === 'right' )
        moveLeftOrRight( joystickXDirection, speedTruck * elapsedTime )

      if ( joystickYDirection === 'up' || joystickYDirection === 'down' )
        moveForwordOrBackword(( joystickYDirection === 'up' ) ? 'forword' : 'backword', speedForword * elapsedTime )

      joystickStartTime = currentTime
    }
  }, 1);
}

function stopJoystick() {
  clearInterval( joystickTimer )
}

function handleJoystickEvent( evt, data ) {
  if ( evt.type === 'start' ) {
    startJoystick()
  }
  else if ( evt.type === 'end' ) {
    stopJoystick()
  }
  else if ( evt.type === 'move' ) {
    if ( data !== undefined && data.direction !== undefined ) {
      // console.log('distance: ', data.distance)
      // console.log('radian: ', data.angle.radian)
      // console.log('degree: ', data.angle.degree)
      // console.log('x: ', data.direction.x)
      // console.log('y: ', data.direction.y)
      // console.log('angle: ', data.direction.angle)

      joystickXDirection = data.direction.x
      joystickYDirection = data.direction.y
      joystickDirectionAngle = data.angle.radian
      joystickSpeed = data.distance / joystickSize
    }
  }
}

function GetQueryString( name ) {
  var reg = new RegExp( "(^|&)" + name + "=([^&]*)(&|$)", "i" )
  var r = window.location.search.substr( 1 ).match( reg ) //获取url中"?"符后的字符串并正则匹配
  var context = ""
  if ( r != null )
      context = decodeURIComponent( r[2] )
  reg = null
  r = null
  return context == null || context == "" || context == "undefined" ? "" : context
}

// const Default = () => (
//   <>
//     <Float>
//       <Splat alphaTest={0.1} src={`${cakewalk}/nike.splat`} scale={0.5} position={[0, 1.6, 2]} />
//     </Float>
//     <Float>
//       <Splat alphaTest={0.1} src={`${cakewalk}/nike.splat`} scale={0.5} position={[0, 1.6, -1.5]} rotation={[Math.PI, 0, Math.PI]} />
//     </Float>
//     <Float>
//       <Splat alphaTest={0.1} src={`${cakewalk}/plush.splat`} scale={0.5} position={[-1.5, 1.6, 1]} />
//     </Float>
//     <Splat src={`${dylanebert}/kitchen-7k.splat`} position={[0, 0.25, 0]} />
//     <GetThreeObject />
//     </>
// )

// function GetThreeObject() {
//   camera = useThree((state) => state.camera)
//   controls = useThree((state) => state.controls)
// }

// const TAA = () => (
//   <>
//     <Splat alphaHash src={`${cakewalk}/nike.splat`} scale={0.5} position={[0, 1.6, 2]} />
//     <Splat alphaHash src={`${cakewalk}/nike.splat`} scale={0.5} position={[0, 1.6, -1.5]} rotation={[Math.PI, 0, Math.PI]} />
//     <Splat alphaHash src={`${cakewalk}/plush.splat`} scale={0.5} position={[-1.5, 1.6, 1]} />
//     <Splat alphaHash src={`${dylanebert}/kitchen-7k.splat`} position={[0, 0.25, 0]} />
//     <Post />
//   </>
// )

// const Phys = () => (
//   <>
//     <Physics>
//       <Shoe position={[0, 5, 0]} />
//       <Shoe position={[0, 7, 0]} rotation-y={0.5} />
//       <Shoe position={[0, 9, 0]} rotation-y={1} />
//       <CuboidCollider position={[0, -0.6, 0]} args={[20, 0.5, 20]} />
//     </Physics>
//     <Splat src={`${dylanebert}/kitchen-7k.splat`} position={[0, 0.25, 0]} />
//   </>
// )

// const Shoe = (props) => (
//   <RigidBody {...props} colliders={false}>
//     <BallCollider position={[-0.5, 0, -0.1]} args={[0.25]} />
//     <BallCollider position={[-0, 0, -0]} args={[0.2]} />
//     <BallCollider position={[0.65, 0, -0]} args={[0.1]} />
//     <CuboidCollider rotation={[0, 0, 0.2]} position={[0.3, -0.1, 0]} args={[0.3, 0.1, 0.2]} />
//     <CuboidCollider rotation={[0, -0.2, -0.1]} position={[-0.4, -0.15, -0.1]} args={[0.3, 0.1, 0.15]} />
//     <CuboidCollider rotation={[0, 0, -0.3]} position={[0.3, 0.05, 0]} args={[0.3, 0.1, 0.15]} />
//     <CuboidCollider rotation={[0, -0.1, 0]} position={[-0.3, 0.15, -0.05]} args={[0.3, 0.1, 0.15]} />
//     <Splat alphaTest={0.1} src={`${cakewalk}/nike.splat`} scale={0.5} position={[-0.05, 1.1, 0.05]} rotation={[-0.51, 0, 0.1]} />
//   </RigidBody>
// )

// function Post() {
//   const taa = useRef(null)
//   const gl = useThree((state) => state.gl)
//   const scene = useThree((state) => state.scene)
//   const camera = useThree((state) => state.camera)
//   const controls = useThree((state) => state.controls)

//   useEffect(() => {
//     const oldToneMapping = gl.toneMapping
//     gl.toneMapping = THREE.NoToneMapping
//     if (controls) {
//       const wake = () => {
//         taa.current.accumulate = false
//         taa.current.sampleLevel = 0
//       }
//       const rest = () => {
//         taa.current.accumulate = true
//         taa.current.sampleLevel = 2
//       }
//       controls.addEventListener('wake', wake)
//       controls.addEventListener('sleep', rest)
//       return () => {
//         gl.toneMapping = oldToneMapping
//         controls.removeEventListener('wake', wake)
//         controls.removeEventListener('sleep', rest)
//       }
//     }
//   }, [controls])

//   return (
//     <Effects disableRenderPass disableGamma>
//       <tAARenderPass ref={taa} accumulate={true} sampleLevel={2} args={[scene, camera]} />
//       <outputPass />
//     </Effects>
//   )
// }
